import { FaLock } from "react-icons/fa";
import AOS from "aos";
import React, { useEffect } from "react";

export default function Breadcum({ text }) {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <div className="flex text-red-600 items-center gap-2 justify-start mb-4" data-aos="fade-right" data-aos-delay="200">
      <span>
        <FaLock />
      </span>
      <h4 className="text-red-600 font-bold uppercase">{text}</h4>
    </div>
  );
}
